<div style="position: relative;" [style.height]="height">
  <canvas #canvas class="chart-canvas"></canvas>
</div>
